import { FC, useEffect } from "react";
import { Outlet } from "react-router-dom";

const chatScreen: FC = () => {
  return <Outlet />;
};

export default chatScreen;
